export default "__VITE_ASSET__b1cc6428__"